import { SERVICE_STATUS } from '@bagonboard/wiseman';

export const SERVICE_STATUS_COLORS = {
  [SERVICE_STATUS.ASSIGNED]       : '#1973e8',
  [SERVICE_STATUS.BLOCKED]        : '#d0505f',
  [SERVICE_STATUS.CANCELLED]      : '#d0505f',
  [SERVICE_STATUS.COMPLETED]      : '#39A472',
  [SERVICE_STATUS.DECLINED]       : '#d0505f',
  [SERVICE_STATUS.ON_VERIFICATION]: '#1973e8',
  [SERVICE_STATUS.PENDING]        : '#1973e8',
  [SERVICE_STATUS.PROCESSING]     : '#9b770e',
};

export const SERVICE_STATUS_TITLES = {
  [SERVICE_STATUS.ASSIGNED]       : 'Assigned',
  [SERVICE_STATUS.BLOCKED]        : 'Blocked',
  [SERVICE_STATUS.CANCELLED]      : 'Cancelled',
  [SERVICE_STATUS.COMPLETED]      : 'Completed',
  [SERVICE_STATUS.DECLINED]       : 'Declined',
  [SERVICE_STATUS.ON_VERIFICATION]: 'On Verification',
  [SERVICE_STATUS.PENDING]        : 'Pending',
  [SERVICE_STATUS.PROCESSING]     : 'Processing',
};
